module.exports = __webpack_public_path__ + "static/stainguard-be3dd331eca5b11cf11bebe6f4921f78.jpg";